import {Row, SortOrder} from '@/components/ui/table/table.model';

function isNil(value: unknown): boolean {
	return value === undefined || value === null;
}

function normalize(value: unknown): unknown {
	return typeof value === 'string' ? value.toUpperCase() : value;
}

function greaterThan(a: unknown, b: unknown): boolean {
	if (typeof a === 'number' && typeof b === 'number') {
		return a > b;
	}
	return String(a) > String(b);
}

/** Same ordering as the default sort of the former Buefy table: nulls last when ascending, strings case-insensitive. */
export function compareValues(a: unknown, b: unknown, order: SortOrder): number {
	const asc = order === 'asc';
	if (typeof a === 'boolean' && typeof b === 'boolean') {
		return asc ? Number(a) - Number(b) : Number(b) - Number(a);
	}
	if (!isNil(b) && isNil(a)) {
		return asc ? 1 : -1;
	}
	if (!isNil(a) && isNil(b)) {
		return asc ? -1 : 1;
	}
	if (a === b) {
		return 0;
	}
	const greater = greaterThan(normalize(a), normalize(b));
	return asc ? (greater ? 1 : -1) : (greater ? -1 : 1);
}

export function sortRows<T extends Row>(rows: T[], field: string, order: SortOrder): T[] {
	return [...rows].sort((a, b) => compareValues(a[field], b[field], order));
}
